'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'flag-checkered';
var width = 448;
var height = 512;
var aliases = [127937];
var unicode = 'f11e';
var svgPathData = ['M64 246.2l69-17.2c19.4-4.9 39.4-6.1 59-3.8V331.8c20.3 2.4 40.2 8.3 58.7 17.5c21.8 10.9 45.4 17.1 69.3 18.5V258.7c25.2 0 50.4-5.8 73.6-17.4L448 214.2v-96l-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4V60.6c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3V129.1c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4v96c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3v-96c-19.6-2.3-39.6-1.1-59 3.8L64 150.2v96z', 'M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c21-5.2 42.6-6.6 63.7-4.1V225.1c-19.6-2.3-39.6-1.1-59 3.8L64 246.2v-96l69-17.2c19.4-4.9 39.4-6.1 59-3.8v96c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4V367.8c24.4 1.4 49.1-2.2 72.5-11l34.7-13c12.5-4.7 20.8-16.6 20.8-30V214.2l-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4v-96c25.2 0 50.4-5.8 73.6-17.4L448 118.2v-52c0-23-24.2-38-44.8-27.7l-9.6 4.8C370.4 54.8 345.2 60.6 320 60.6V162.7c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3V27c-19.6-2.3-39.6-1.1-59 3.8L64 48V32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlagCheckered = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;